// extracted by mini-css-extract-plugin
module.exports = {"paymentsMessagePay":"styles_paymentsMessagePay__p-BJL"};